import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import JobAdTemplateManualJobEco2solar from "~/components/job-page/subclients/eco2solar/jobad-template-manual-job-eco2solar";
import ApplicationProcessMailFirstEon from "~/components/job-page/subclients/shared/application-process-mail-first-eon";

export const defaultEco2solar = createSubtemplate<SectionKey>({
  name: "eco2solar",
  trigger: () => true,
  showProd: true,
  config: {
    overrides: {
      jobDescription: JobAdTemplateManualJobEco2solar,
      applicationProcess: ApplicationProcessMailFirstEon,
    },
    sections: [
      "stickyContact",
      "headerImage",
      "breadcrumb",
      "companyInfo",
      "jobDescription",
      "contact",
      "applicationProcess",
      "diversity",
      "about",
      "benefits",
      "similarJobs",
      "printView",
    ],
  },
});
